import "./anotheritem.css"
import { useContextSelector } from '@fluentui/react-context-selector';
import { StoreContext } from "../../context";
import { Box } from "@material-ui/core";
import AmsProductList from "../../molecules/AmsProductList/AmsProductList";
import { useEffect, useState } from "react";
import AmsButton from "../../atoms/AmsButton/AmsButton";
import AmsTypography from "../../atoms/AmsTypography/AmsTypography";
import AmsDivider from "../../atoms/AmsDivider/AmsDivider";
import { navigate, useLocation } from "@reach/router";
import MessageBlock from "../../molecules/MessageBlock/MessageBlock";
import AnotherItemList from "../../molecules/AnotherItemList/AnotherItemList";
import { getMobileOperatingSystem } from "../../utils/helpers";
import { makeStyles } from '@material-ui/core/styles';


const useStyles = makeStyles({
    buttonContainer: {
        // padding: "4vw",
        // width: "92vw",
        background: "linear-gradient(0deg, rgba(255,255,255,1) 0%, rgba(255,255,255,1) 70%, rgba(255,255,255,0) 100%)",
        marginBottom: (props: any) => props?.os === "iOS" ? "0px" : "0px",
        display: 'flex',
        alignItems: 'flex-end',
    },
});

const AnotherItem = (props: any) => {
    const { title, btnProps, messageBlock } = props?.templateProps
    const location = useLocation()


    const [otherRoom, setOtherRoom] = useState<any>()

    let os: any = getMobileOperatingSystem();

    const classes = useStyles({ os: os });



    const handleSubmit = () => {
        navigate(btnProps?.nextScreen)

    }

    useEffect(() => {
        let roomInfo: any = sessionStorage.getItem("roomInfo")
        const filteredItems: any = [];


        if (roomInfo) {
            roomInfo = JSON.parse(roomInfo);
            roomInfo.forEach((roomData: any) => {
                Object.values(roomData).forEach((itemData: any) => {
                    itemData.forEach((item: any) => {
                        if (item.quantity === 0) {
                            filteredItems.push(item);
                        }
                    });
                });
            });



        }


        const uniqueItems = filteredItems.reduce((acc: any, current: any) => {
            const x = acc.find((item: any) => item.item === current.item);
            if (!x) {
                return acc.concat([current]);
            } else {
                return acc;
            }
        }, []);
        setOtherRoom(uniqueItems)
    }, [])

    const Products = (props: any) => {

     
        return (
            <AnotherItemList list={otherRoom} roomType={"Other Room"} />
        )
    }

    return (
        <Box className="baseContainerBlock HomeBlock">
            <Box className="mainContainer">
                <Box className="title" mb={5}>
                    <AmsTypography variant="h1" text={title} />
                </Box>
                <Box mb={5} mt={5}>
                    <AmsDivider />
                </Box>
                <Products />
                <Box mb={5} mt={5} className="messageBlock">
                    {messageBlock && <MessageBlock message={messageBlock?.text} />}
                </Box>
            </Box>
            <Box className="buttonContainerBlock" >
                <Box className="buttonContainerBlock" >
                    <Box className={classes.buttonContainer}>
                        <AmsButton
                            attributes={btnProps?.attributes}
                            handleClick={handleSubmit}
                        />
                    </Box>
                </Box>
            </Box>
        </Box>
    )
}

export default AnotherItem;